var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section"},[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.cat))]),_c('RecipeList',{attrs:{"recipes":_vm.recipes}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }